import type { Distance, Margins, SpatialRectangle } from "@pdfking/math"
import type { PageShape } from "@pdfking/renderer-api"
import type { StringGUID } from "@pdfking/tfunc"

import { PageMetrics } from "../layout/PageMetrics"
import { DrawBackpackGrid } from "../pattern/DrawBackpackGrid"
import { CreateRandom } from "../random/CreateRandom"

// The inside of the back cover in `box`: the pattern as endpaper, running on
// into `bleed`
export const DrawBackCoverBack = ({
  bleed,
  box,
  seed,
}: {
  bleed: Margins<Distance>
  box: SpatialRectangle<Distance>
  seed: StringGUID
}): PageShape[] =>
  DrawBackpackGrid({
    bleed,
    box,
    random: CreateRandom(seed, "back cover back"),
    short: PageMetrics(box).short,
  })
